import { Box, Stack, StackProps, SxProps, Theme } from '@mui/material'
import { FC, PropsWithChildren } from 'react'

import joinChildren from '../../utils/component/joinChildren'

interface InfoListProps {
  columnGap?: StackProps['columnGap']
  hideSeparator?: boolean
  sx?: SxProps<Theme>
  wrap?: boolean
}

const InfoList: FC<PropsWithChildren<InfoListProps>> = ({
  children,
  columnGap = 1.5,
  hideSeparator,
  sx,
  wrap,
}) => {
  return (
    <Stack
      alignItems="center"
      columnGap={columnGap}
      direction="row"
      flexWrap={wrap ? 'wrap' : 'nowrap'}
      rowGap={0.5}
      sx={sx}
    >
      {hideSeparator
        ? children
        : joinChildren(
            children,
            <Box component="span" color="grey.500">
              &bull;
            </Box>
          )}
    </Stack>
  )
}

export default InfoList
